import { A } from '@solidjs/router';
import { For, type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { ApiBlocker } from '../lib/blockers';
import { orgHref } from '../lib/org';
import { BlockerFixLink } from './BlockerFixLink';
import { BlockerNeeds } from './BlockerNeeds';
import { Panel } from './Panel';
import { buttonClass } from './ui/Button';

// The open access asks on one repo, on the repo view (epic #3756). Presenter —
// `<RepoAccessBlockers/>` reads and narrows; this renders each ask's fields
// inline (landed ones marked supplied) and its CTA, which is the FIX PAGE itself:
// the one-link form is where the values go, partial-fill and write-once per field.
//
// NO ANSWER OR WITHDRAW CONTROL HERE. Those write a blocker, and the Blockers
// page is the one place that does — with the run-ended sentence beside the
// answer box that a reader must see before sending. So the second link goes
// there, deep-linked to this row.

export function RepoAccessPanel(props: { readonly blockers: readonly ApiBlocker[] }): JSX.Element {
  return (
    <Panel title={t('repo_detail.access_title')} class="repo-access">
      <p class="card__desc">{t('repo_detail.access_desc')}</p>
      <For each={props.blockers}>
        {(blocker) => (
          <div class="repo-access__ask">
            <h3 class="repo-access__summary">{blocker.summary}</h3>
            <Show when={blocker.needs}>{(needs) => <BlockerNeeds needs={needs()} />}</Show>
            <Show when={blocker.fix_url}>{(url) => <BlockerFixLink url={url()} />}</Show>
            <A
              class={`${buttonClass({ variant: 'link' })} repo-access__answer`}
              href={orgHref(`/blockers?blocker=${encodeURIComponent(blocker.id)}`)}
            >
              {t('repo_detail.access_open_blockers')}
            </A>
          </div>
        )}
      </For>
    </Panel>
  );
}
